export default __webpack_public_path__ + "static/media/pictogramBeaconCurrency128.977b71a5.svg";